// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1T9RK","left":"InfoRow_left__14tfR"};